import { removeFromBox, upsertBox } from 'common/Prose/Commands/boxAndQuotes'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { isTableSelection } from 'common/Prose/utils/table'
import { last } from 'lodash'
import { comparer, computed } from 'mobx'
import { schema } from 'prose-core'
import { useContext } from 'react'
import { AlmanacEditorStateContext, SelectionType } from 'stores/EditorState'

export const useCalloutButton = () => {
  const view = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const disabled = computed(
    () =>
      almanacState.selectionIncludesSomeNodeTypes(schema.nodes.code_block) ||
      almanacState.selectionType === SelectionType.Cell ||
      isTableSelection(almanacState.selection),
  ).get()

  const setColor = (color: string) => {
    const tr = upsertBox(view.state, color)
    view.dispatch(tr)
    view.focus()
  }

  const removeColor = () => {
    const { state } = view
    const { tr } = state

    removeFromBox(state, tr, { box: true })
    view.dispatch(tr)
    view.focus()
  }

  const { activeColors, active } = computed(
    () => {
      const { selection } = almanacState
      const { doc } = view.state
      const colors: string[] = []

      for (const range of selection.ranges) {
        doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos, parent) => {
          if (node.type === schema.nodes.box) {
            const { boxColor } = node.attrs
            if (boxColor && last(colors) !== boxColor) colors.push(boxColor)
            // Don't further descend into blocks past depth of 1
            return false
          }
        })
      }

      return { activeColors: colors, active: colors.length > 0 }
    },
    { equals: comparer.structural },
  ).get()

  return { activeColors, active, setColor, removeColor, disabled }
}
